import React from 'react';
import Layout from 'layout/Layout';
import { useGetAllInquiresQuery } from 'api/inquiryApi';

const Inquiry = () => {
  const { data, isLoading, isError } = useGetAllInquiresQuery();

  return (
    <Layout title="Inquires" tagline="Manage All Incoming Inquiries in One Place">
      <>
        {isLoading ? (
          <p className="text-center mt-20 text-blue-500">Loading inquiries...</p>
        ) : isError ? (
          <p className="text-center mt-20 text-red-500">Failed to load inquiries. Please try again later.</p>
        ) : (
          <div className="mt-12 md:mt-20 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 px-4 sm:px-6 md:px-8 lg:px-12 pb-10">
            {data?.data?.map((inquiry) => (
              <div
                key={inquiry.id}
                className="bg-white border border-gray-200 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden max-w-full min-w-0"
              >
                <div className="bg-gray-100 px-5 py-4 border-b border-gray-200">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-800 truncate">{inquiry.name}</h3>
                  <p className="text-xs sm:text-sm text-gray-500 truncate">{inquiry.email}</p>
                </div>
                <div className="p-5 space-y-2 text-xs sm:text-sm text-gray-700 leading-relaxed max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                  <p><strong>📞 Phone:</strong> {inquiry.phone_number}</p>
                  <p><strong>📌 Subject:</strong> {inquiry.subject}</p>
                  <p><strong>📝 Message:</strong> {inquiry.message || 'N/A'}</p>
                  <p><strong>🌍 City/State:</strong> {inquiry.city_state}</p>
                  <p><strong>🏷️ Pincode:</strong> {inquiry.pincode}</p>
                  <p><strong>🏠 Address:</strong> {inquiry.address}</p>
                  <p><strong>🛠️ Service Interested In:</strong> {inquiry.service_looking_for}</p>
                  <p><strong>📄 Requirements:</strong> {inquiry.requirements || 'N/A'}</p>
                  <p><strong>⏰ Time to Call:</strong> {inquiry.time_to_call}</p>
                  <p><strong>📣 Heard About Us From:</strong> {inquiry.here_aboutus_from}</p>
                  <p className="text-xs text-gray-500 mt-2">
                    <strong>🕓 Received On:</strong> {new Date(inquiry.created_at).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    </Layout>
  );
};

export default Inquiry;
